module.exports = __webpack_public_path__ + "img/Path 753-3.daec4637.svg";